"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSchemaType = void 0;
var UniversalSchemaType;
(function (UniversalSchemaType) {
    UniversalSchemaType["AUDIO"] = "audio";
    UniversalSchemaType["BINARY_CHOICE"] = "binary-choice";
    UniversalSchemaType["BOUNDING_BOX"] = "bounding-box";
    UniversalSchemaType["CAMERA_INTRINSICS"] = "camera-intrinsics";
    UniversalSchemaType["CHOICE"] = "choice";
    UniversalSchemaType["CIRCLE"] = "circle";
    UniversalSchemaType["COLOR"] = "color";
    UniversalSchemaType["CUBOID"] = "cuboid";
    UniversalSchemaType["DIRECTED_EDGE"] = "directed-edge";
    UniversalSchemaType["DIRECTED_POLYGON"] = "directed-polygon";
    UniversalSchemaType["DIRECTION"] = "direction";
    UniversalSchemaType["EDGE"] = "edge";
    UniversalSchemaType["ELLIPSE"] = "ellipse";
    UniversalSchemaType["EXCLUSIVE_CHOICE"] = "exclusive-choice";
    UniversalSchemaType["IMAGE_BOUNDING_BOX"] = "image-bounding-box";
    UniversalSchemaType["IMAGE_CIRCLE"] = "image-circle";
    UniversalSchemaType["IMAGE_CUBOID"] = "image-cuboid";
    UniversalSchemaType["IMAGE_DIRECTED_POLYGON"] = "image-directed-polygon";
    UniversalSchemaType["IMAGE_ELLIPSE"] = "image-ellipse";
    UniversalSchemaType["IMAGE_INSTANCE_SEGMENTATION"] = "image-instance-segmentation";
    UniversalSchemaType["IMAGE_KEYPOINT"] = "image-key-point";
    UniversalSchemaType["IMAGE_LINE"] = "image-line";
    UniversalSchemaType["IMAGE_POINT"] = "image-point";
    UniversalSchemaType["IMAGE_POLYGON"] = "image-polygon";
    UniversalSchemaType["IMAGE"] = "image";
    UniversalSchemaType["IMAGE_SEGMENT"] = "image-segment";
    UniversalSchemaType["IMAGE_SEMANTIC_SEGMENTATION"] = "image-semantic-segmentation";
    UniversalSchemaType["IMAGE_SEQUENCE_BOUNDING_BOX"] = "image-sequence-bounding-box";
    UniversalSchemaType["IMAGE_SEQUENCE_CUBOID"] = "image-sequence-cuboid";
    UniversalSchemaType["IMAGE_TRANSCRIPTION"] = "image-transcription";
    UniversalSchemaType["INDEXED_EDGE"] = "indexed-edge";
    UniversalSchemaType["INTEGER"] = "integer";
    UniversalSchemaType["KEYPOINT"] = "key-point";
    UniversalSchemaType["LINE"] = "line";
    UniversalSchemaType["MULTIPLE_CHOICE"] = "multiple-choice";
    UniversalSchemaType["NUMBER"] = "number";
    UniversalSchemaType["POINT"] = "point";
    UniversalSchemaType["POLYGON"] = "polygon";
    UniversalSchemaType["QUATERNION"] = "quaternion";
    UniversalSchemaType["SATELLITE"] = "satellite";
    UniversalSchemaType["STRUCTURED_TEXT"] = "structured-text";
    UniversalSchemaType["TEXT_ANNOTATION"] = "text-annotation";
    UniversalSchemaType["TEXT"] = "text";
    UniversalSchemaType["TEXT_SEGMENT"] = "text-segment";
    UniversalSchemaType["TRANSCRIPTION"] = "transcription";
    UniversalSchemaType["UNIVERSAL"] = "universal";
    UniversalSchemaType["URL"] = "url";
    UniversalSchemaType["VIDEO_BOUNDING_BOX"] = "video-bounding-box";
    UniversalSchemaType["VIDEO_CUBOID"] = "video-cuboid";
    UniversalSchemaType["VIDEO"] = "video";
})(UniversalSchemaType = exports.UniversalSchemaType || (exports.UniversalSchemaType = {}));
